import React, {useState} from 'react'
import RootAdmin from '../../../../components/layouts/RootAdmin'
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownTrigger,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableColumn,
    TableHeader,
    TableRow,
    Spinner
} from '@nextui-org/react'
import HeaderPage from '../../../../components/elements/HeaderPage'
import { FunnelIcon } from '@heroicons/react/24/outline'
import { BarChart } from '@mui/x-charts/BarChart';
import useSWR from "swr";
import {getFetcher, HIGHCHART_URL} from "../../../../services/api";
import {useForm} from "react-hook-form";
import ControlledInput from "../../../../components/elements/ControlledInput";
import {format} from 'date-fns'
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';
import { isiSel, judulKolom, kelasKolom, kelasKolomDariData } from "../../../../services/angkaTabel";

// Initialize Highcharts exporting modules
highchartsExporting(Highcharts);

export default function PengangkutanGrafik() {
    const currentDate = new Date();
    const formattedDate = format(currentDate, 'dd-MM-yyyy');
    // Bawaan lama adalah hari ini sampai hari ini - satu hari, yang praktis
    // tidak pernah ada laporannya, sehingga dasbor selalu terlihat kosong saat
    // dibuka. Bawaan sekarang: awal tahun berjalan sampai hari ini.
    const awalTahun = format(new Date(currentDate.getFullYear(), 0, 1), 'dd-MM-yyyy');
    const [startDate, setStartDate] = useState(awalTahun);
    const [endDate, setEndDate] = useState(formattedDate);

    const swrOptions = { revalidateOnFocus: false };

    // Endpoint SWR
    const { data: jumlahB3JenisB3, isLoading: loadingB3JenisB3, mutate: mutateB3JenisB3 } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/jumlah-b3-jenis-b3?startDate=${startDate}&endDate=${endDate}`,
        getFetcher, swrOptions
    );

    const { data: jumlahB3Provinsi, isLoading: loadingB3Provinsi, mutate: mutateB3Provinsi } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/jumlah-b3-tujuan-provinsi?startDate=${startDate}&endDate=${endDate}`,
        getFetcher, swrOptions
    );

    const { data: perusahaanTujuanBongkar, isLoading: loadingPerusahaanBongkar, mutate: mutatePerusahaanBongkar } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/perusahaan-tujuan-bongkar?startDate=${startDate}&endDate=${endDate}`,
        getFetcher, swrOptions
    );

    const { data: bahanB3Diangkut, isLoading: loadingBahanB3Diangkut, mutate: mutateBahanB3Diangkut } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/bahanb3-diangkut?startDate=${startDate}&endDate=${endDate}`,
        getFetcher, swrOptions
    );

    const { data: perusahaanPengangkutTerbanyak, isLoading: loadingPengangkutTerbanyak, mutate: mutatePengangkutTerbanyak } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/perusahaan-pengangkut-terbanyak?startDate=${startDate}&endDate=${endDate}`,
        getFetcher, swrOptions
    );

    const { data: perbandinganAplikasi, isLoading: loadingPerbandinganAplikasi, mutate: mutatePerbandinganAplikasi } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/perbandingan-aplikasi?startDate=${startDate}&endDate=${endDate}`,
        getFetcher, swrOptions
    );


    const { data: b3, mutate: mutateB3 } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/grafik?startDate=${startDate}&endDate=${endDate}&groupBy=bahanb3`,
        getFetcher
    );

    const { data: perusahaan, mutate: mutatePerusahaan } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/grafik?startDate=${startDate}&endDate=${endDate}&groupBy=perusahaan`,
        getFetcher
    );

    const { data: kendaraan, mutate: mutateKendaraan } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/grafik/kendaraan?startDate=${startDate}&endDate=${endDate}&groupBy=`,
        getFetcher
    );

    const { data: perusahaanPelaporan, mutate: mutatePerusahaanPelaporan } = useSWR(
        `/api/dashboard/pelaporan-pengangkutan/grafik/perusahaan?startDate=${startDate}&endDate=${endDate}&groupBy=`,
        getFetcher
    );

    const handleFilterApply = (start, end) => {
        setStartDate(start);
        setEndDate(end);
        mutateB3();
        mutatePerusahaan();
        mutateB3JenisB3();
        mutateB3Provinsi();
        mutatePerusahaanBongkar();
        mutateBahanB3Diangkut();
        mutatePengangkutTerbanyak();
        mutatePerbandinganAplikasi();
    };

    return (<RootAdmin>
            <HeaderPage
                title="Grafik Pelaporan Pengangkutan"
                subtitle="Gambaran Umum"
                action={<FilterForm onApplyFilter={handleFilterApply}/>}
            />
            <div className='grid grid-rows-1 md:grid-rows-4 gap-3 pt-5'>
                <Card>
                    <Tabs aria-label="Pelaporan Grafik B3" defaultValue="PelaporanGrafik">
                    <Tab title="Jumlah B3 dan Jenis B3" value="B3Terbanyak">
                        <DataChartTable
                            data={jumlahB3JenisB3?.responseData}
                            loading={loadingB3JenisB3}
                            title="Jumlah B3 dan Jenis B3"
                            xAxisKey="jenisB3"
                            yAxisKey="totalJumlahB3"
                        />
                    </Tab>
                    <Tab title="Jumlah B3 Berdasarkan Provinsi" value="B3Provinsi">
                        <DataChartTable
                            data={jumlahB3Provinsi?.responseData}
                            loading={loadingB3Provinsi}
                            title="Jumlah B3 Berdasarkan Provinsi"
                            xAxisKey="namaProvinsi"
                            yAxisKey="totalJumlahB3"
                        />
                    </Tab>
                    <Tab title="Perusahaan Tujuan Bongkar" value="PerusahaanBongkar">
                        <DataChartTable
                            data={perusahaanTujuanBongkar?.responseData}
                            loading={loadingPerusahaanBongkar}
                            title="Perusahaan Tujuan Bongkar"
                            xAxisKey="perusahaan"
                            yAxisKey="totalJumlahB3"
                        />
                    </Tab>
                    <Tab title="Bahan B3 Diangkut" value="BahanB3Diangkut">
                        <DataChartTable
                            data={bahanB3Diangkut?.responseData}
                            loading={loadingBahanB3Diangkut}
                            title="Bahan B3 Diangkut"
                            xAxisKey="namaBahanKimia"
                            yAxisKey="jumlahDiangkut"
                        />
                    </Tab>
                    <Tab title="Perusahaan Pengangkut Terbanyak" value="PengangkutTerbanyak">
                        <DataChartTable
                            data={perusahaanPengangkutTerbanyak?.responseData}
                            loading={loadingPengangkutTerbanyak}
                            title="Perusahaan Pengangkut Terbanyak"
                            xAxisKey="perusahaan"
                            yAxisKey="totalJumlahB3"
                        />
                    </Tab>
                    <Tab title="Perbandingan Aplikasi" value="PerbandinganAplikasi">
                        <DataChartTable
                            data={perbandinganAplikasi?.responseData}
                            loading={loadingPerbandinganAplikasi}
                            title="Perbandingan Aplikasi yang Dilaporkan"
                            xAxisKey="kodePermohonan"
                            yAxisKey="isReported"
                        />
                    </Tab>

                        <Tab title="Grafik Besaran B3 Terbanyak Diangkut" value="B3Terbanyak">
                            <Card radius='sm' className='col-span-4'>
                                <CardHeader>
                                    <span className='text-primary text-xl font-bold'>10 Jenis B3 Terbanyak Diangkut</span>
                                </CardHeader>
                                <CardBody className='w-full'>
                                <HighchartsReact
                                    containerProps={{ style: { width: "100%" } }}
                                    highcharts={Highcharts}
                                    options={{
                                        chart: {
                                            type: "column",
                                            height: 420,
                                        },
                                        title: {
                                            text: "10 Jenis B3 Terbanyak Diangkut",
                                        },
                                        xAxis: {
                                            categories: (b3 || []).map((item) => item.name), // Dynamic x-axis categories
                                            title: {
                                                text: "Jenis B3",
                                            },
                                        },
                                        yAxis: {
                                            min: 0,
                                            title: {
                                                text: "Jumlah",
                                            },
                                            labels: {
                                                overflow: "justify",
                                            },
                                        },
                                        series: [
                                            {
                                                name: "Jumlah",
                                                data: (b3 || []).map((item) => item.count), // Data for the bar chart
                                            },
                                        ],
                                        exporting: {
                                            url: HIGHCHART_URL,
                                            enabled: true,
                                            showTable: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                dataLabels: {
                                                    enabled: true,
                                                },
                                            },
                                        },
                                    }}
                                />

                                </CardBody>
                            </Card>
                            <div className='col-span-4 mt-5'>
                                <Table aria-label="Example static collection table">
                                    <TableHeader>
                                        <TableColumn>Nomor CAS</TableColumn>
                                        <TableColumn>Jenis B3</TableColumn>
                                        <TableColumn className="text-right">Jumlah</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {(b3 || []).map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.casNumber || "-"}</TableCell>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell className="text-right tabular-nums">{isiSel("jumlah", item.count)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Tab>

                        <Tab title="Grafik Pengangkutan B3 Berdasarkan Perusahaan" value="B3TerbanyakPerusahaan">
                            <Card radius='sm' className='col-span-4'>
                                <CardHeader>
                                    <span className='text-primary text-xl font-bold'>10 Perusahaan Pengangkutan Terbanyak</span>
                                </CardHeader>
                                <CardBody className='w-full'>
                                <HighchartsReact
                                    containerProps={{ style: { width: "100%" } }}
                                    highcharts={Highcharts}
                                    options={{
                                        chart: {
                                            type: "column",
                                            height: 420,
                                        },
                                        title: {
                                            text: "10 Perusahaan Pengangkutan Terbanyak",
                                        },
                                        xAxis: {
                                            categories: (perusahaan || []).map((item) => item.name), // Dynamic x-axis categories
                                            title: {
                                                text: "Perusahaan",
                                            },
                                        },
                                        yAxis: {
                                            min: 0,
                                            title: {
                                                text: "Jumlah",
                                            },
                                            labels: {
                                                overflow: "justify",
                                            },
                                        },
                                        series: [
                                            {
                                                name: "Jumlah",
                                                data: (perusahaan || []).map((item) => item.count), // Data for the bar chart
                                            },
                                        ],
                                        exporting: {
                                            url: HIGHCHART_URL,
                                            enabled: true,
                                            showTable: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                dataLabels: {
                                                    enabled: true, // Show data labels on bars
                                                },
                                            },
                                        },
                                    }}
                                />
                                </CardBody>
                            </Card>
                            <div className='col-span-4 mt-5'>
                                <Table aria-label="Example static collection table">
                                    <TableHeader>
                                        <TableColumn>Perusahaan</TableColumn>
                                        <TableColumn className="text-right">Jumlah Diangkut</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {(perusahaan || []).map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell className="text-right tabular-nums">{isiSel("jumlah", item.count)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Tab>

                        <Tab title="Grafik Kendaraan" value="B3TerbanyakPerusahaan">
                            <Card radius='sm' className='col-span-4'>
                                <CardHeader>
                                    <span className='text-primary text-xl font-bold'>Data Pelaporan Kendaraan</span>
                                </CardHeader>
                                <CardBody className='w-full'>
                                <HighchartsReact
                                    containerProps={{ style: { width: "100%" } }}
                                    highcharts={Highcharts}
                                    options={{
                                        chart: {
                                            type: "column",
                                        },
                                        title: {
                                            text: "Data Pelaporan Kendaraan",
                                        },
                                        xAxis: {
                                            categories: (kendaraan || []).map((item) => item.modelKendaraan), // Dynamic x-axis categories
                                            title: {
                                                text: "Kendaraan",
                                            },
                                        },
                                        yAxis: {
                                            min: 0,
                                            title: {
                                                text: "Jumlah",
                                            },
                                            labels: {
                                                overflow: "justify",
                                            },
                                        },
                                        series: [
                                            {
                                                name: "Jumlah",
                                                data: (kendaraan || []).map((item) => item.total), // Data for the bar chart
                                            },
                                        ],
                                        exporting: {
                                            url: HIGHCHART_URL,
                                            enabled: true,
                                            showTable: true,
                                        },
                                        plotOptions: {
                                            column: {
                                                dataLabels: {
                                                    enabled: true, // Show data labels on bars
                                                },
                                            },
                                        },
                                    }}
                                />
                                </CardBody>
                            </Card>
                            <div className='col-span-4 mt-5'>
                                <Table aria-label="Example static collection table">
                                    <TableHeader>
                                        <TableColumn>Model</TableColumn>
                                        <TableColumn>No Polisi</TableColumn>
                                        <TableColumn>No Mesin</TableColumn>
                                        <TableColumn>No Rangka</TableColumn>
                                        <TableColumn>Tahun Kendaraan</TableColumn>
                                        <TableColumn className="text-right">Jumlah</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {(kendaraan || []).map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.modelKendaraan}</TableCell>
                                                <TableCell>{item.noPolisi}</TableCell>
                                                <TableCell>{item.nomorMesin}</TableCell>
                                                <TableCell>{item.nomorRangka}</TableCell>
                                                <TableCell>{item.tahunPembuatan}</TableCell>
                                                <TableCell className="text-right tabular-nums">{isiSel("jumlah", item.total)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Tab>

                        <Tab title="Grafik Perusahaan Yang Melakukan Pelaporan" value="B3TerbanyakPerusahaan">
                            <Card radius='sm' className='col-span-4'>
                                <CardHeader>
                                    <span className='text-primary text-xl font-bold'>Data Perusahaan Yang Melakukan Pelaporan</span>
                                </CardHeader>
                                <CardBody className='w-full flex flex-col'>
                                <HighchartsReact
                                    containerProps={{ style: { width: "100%" } }}
                                    highcharts={Highcharts}
                                    options={{
                                        chart: {
                                            type: "column",
                                            height: 420,
                                        },
                                        title: {
                                            text: "Data Perusahaan Yang Melakukan Pelaporan",
                                        },
                                        xAxis: {
                                            categories: (perusahaanPelaporan || []).map((item) => item.name), // Dynamic x-axis categories
                                            title: {
                                                text: "Perusahaan",
                                            },
                                        },
                                        yAxis: {
                                            min: 0,
                                            title: {
                                                text: "Jumlah Pelaporan",
                                            },
                                            labels: {
                                                overflow: "justify",
                                            },
                                        },
                                        series: [
                                            {
                                                name: "Jumlah Pelaporan",
                                                data: (perusahaanPelaporan || []).map((item) => item.total), // Data for the bar chart
                                            },
                                        ],
                                        plotOptions: {
                                            column: {
                                                dataLabels: {
                                                    enabled: true, // Show data labels on top of the bars
                                                },
                                            },
                                        },
                                        exporting: {
                                            url: HIGHCHART_URL,
                                            enabled: true,
                                            showTable: true,
                                        },
                                    }}
                                />
                                </CardBody>
                            </Card>
                            <div className='col-span-4 mt-5'>
                                <Table aria-label="Example static collection table">
                                    <TableHeader>
                                        <TableColumn>Perusahaan</TableColumn>
                                        <TableColumn className="text-right">Jumlah Pelaporan</TableColumn>
                                    </TableHeader>
                                    <TableBody>
                                        {(perusahaanPelaporan || []).map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell className="text-right tabular-nums">{isiSel("jumlah", item.total)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </Tab>
                    </Tabs>
                </Card>
            </div>
        </RootAdmin>)
}

// function DataChartTable({ data, xAxisKey, yAxisKey, title, loading }) {
//     if (loading) {
//         return (
//             <div className='flex justify-center items-center py-10'>
//                 <Spinner size="lg" />
//             </div>
//         );
//     }

//     // Cek apakah data adalah array dan memiliki data
//     const isArrayData = Array.isArray(data) && data.length > 0;
//     const tableColumns = isArrayData ? Object.keys(data[0]) : [];

//     // Handle jika data adalah objek dengan properti tambahan
//     const hasSummary =
//         data?.notReportedApplications !== undefined ||
//         data?.reportedApplications !== undefined ||
//         data?.totalApplications !== undefined;

//     return (
//         <Card radius="sm" className="col-span-4">
//             {/* Bagian Header */}
//             <CardHeader>
//                 <span className="text-primary text-xl font-bold">{title}</span>
//             </CardHeader>

//             {/* Bagian Body */}
//             <CardBody className="w-full flex flex-col items-center py-5 text-center">
//                 {isArrayData ? (
//                     <>
//                         {/* Chart */}
//                         <BarChart
//                             xAxis={[{ scaleType: "band", data: data.map((item) => item[xAxisKey]) }]}
//                             series={[{ data: data.map((item) => item[yAxisKey]) }]}
//                             height={300}
//                         />
//                         {/* Table */}
//                         <div className="w-full mt-5">
//                             <Table aria-label={`${title} Table`}>
//                                 <TableHeader>
//                                     {tableColumns.map((column, index) => (
//                                         <TableColumn key={index}>{judulKolom(column)}</TableColumn>
//                                     ))}
//                                 </TableHeader>
//                                 <TableBody>
//                                     {data.map((item, rowIndex) => (
//                                         <TableRow key={rowIndex}>
//                                             {tableColumns.map((column, colIndex) => (
//                                                 <TableCell key={colIndex}>
//                                                     {item[column] !== null && item[column] !== undefined
//                                                         ? item[column]
//                                                         : "-"}
//                                                 </TableCell>
//                                             ))}
//                                         </TableRow>
//                                     ))}
//                                 </TableBody>
//                             </Table>
//                         </div>
//                     </>
//                 ) : hasSummary ? (
//                     <>
//                         {/* Summary Data */}
//                         <div className="w-full mt-5">
//                             <Table aria-label="Summary Table">
//                                 <TableHeader>
//                                     <TableColumn>METRIC</TableColumn>
//                                     <TableColumn>VALUE</TableColumn>
//                                 </TableHeader>
//                                 <TableBody>
//                                     <TableRow>
//                                         <TableCell>Total Permohonan</TableCell>
//                                         <TableCell>{data.totalApplications || 0}</TableCell>
//                                     </TableRow>
//                                     <TableRow>
//                                         <TableCell>Permohonan Dilaporkan</TableCell>
//                                         <TableCell>{data.reportedApplications || 0}</TableCell>
//                                     </TableRow>
//                                     <TableRow>
//                                         <TableCell>Permohonan Belum Dilaporkan</TableCell>
//                                         <TableCell>{data.notReportedApplications || 0}</TableCell>
//                                     </TableRow>
//                                 </TableBody>
//                             </Table>
//                         </div>
//                     </>
//                 ) : (
//                     <span className="text-ink-500">Tidak ada data tersedia.</span>
//                 )}
//             </CardBody>
//         </Card>
//     );
// }

function DataChartTable({ data, xAxisKey, yAxisKey, title, loading }) {
    if (loading) {
        return (
            <div className="flex justify-center items-center py-10">
                <Spinner size="lg" />
            </div>
        );
    }

    const getBarChartOptions = (title, categories, data) => ({
        chart: {
            type: "column",
            height: 420,
        },
        title: {
            text: title,
        },
        xAxis: {
            categories,
            title: {
                text: null,
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: "Jumlah",
                align: "high",
            },
            labels: {
                overflow: "justify",
            },
        },
        series: [
            {
                name: "Jumlah",
                data,
            },
        ],
        exporting: {
            url: HIGHCHART_URL,
            enabled: true,
            showTable: true,
        },
    });

    // Check if data is an array and has content
    const isArrayData = Array.isArray(data) && data.length > 0;
    const tableColumns = isArrayData ? Object.keys(data[0]) : [];

    // Check for summary data
    const hasSummary =
        data?.notReportedApplications !== undefined ||
        data?.reportedApplications !== undefined ||
        data?.totalApplications !== undefined;

    return (
        <Card radius="sm" className="col-span-4">
            {/* Header */}
            <CardHeader>
                <span className="text-primary text-xl font-bold">{title}</span>
            </CardHeader>

            {/* Body */}
            {/* items-center membuat grafik tidak merentang: Highcharts
                menganggap wadahnya tanpa lebar dan memakai 600px bawaannya. */}
            <CardBody className="w-full flex flex-col py-5">
                {isArrayData ? (
                    <>
                        {/* Highcharts */}
                        <HighchartsReact
                            containerProps={{ style: { width: "100%" } }}
                            highcharts={Highcharts}
                            options={getBarChartOptions(
                                title,
                                data.map((item) => item[xAxisKey]),
                                data.map((item) => item[yAxisKey])
                            )}
                        />
                        {/* Table */}
                        <div className="w-full mt-5">
                            <Table aria-label={`${title} Table`}>
                                <TableHeader>
                                    {tableColumns.map((column, index) => (
                                        <TableColumn key={index} className={kelasKolomDariData(column, data)}>
                                            {judulKolom(column)}
                                        </TableColumn>
                                    ))}
                                </TableHeader>
                                <TableBody>
                                    {data.map((item, rowIndex) => (
                                        <TableRow key={rowIndex}>
                                            {tableColumns.map((column, colIndex) => (
                                                <TableCell key={colIndex} className={kelasKolom(column, item[column])}>
                                                    {isiSel(column, item[column])}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </>
                ) : hasSummary ? (
                    <>
                        {/* Summary Data */}
                        <div className="w-full mt-5">
                            <Table aria-label="Summary Table">
                                <TableHeader>
                                    <TableColumn>METRIC</TableColumn>
                                    <TableColumn>VALUE</TableColumn>
                                </TableHeader>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Total Permohonan</TableCell>
                                        <TableCell>{data.totalApplications || 0}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Permohonan Dilaporkan</TableCell>
                                        <TableCell>{data.reportedApplications || 0}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Permohonan Belum Dilaporkan</TableCell>
                                        <TableCell>{data.notReportedApplications || 0}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                    </>
                ) : (
                    <span className="text-ink-500">Tidak ada data tersedia.</span>
                )}
            </CardBody>
        </Card>
    );
}



function FilterForm({onApplyFilter}) {
    const { control, watch } = useForm({
        defaultValues: {
            startDate: "",
            endDate: "",
        },
    });
    const filters = watch();

    const handleApply = () => {
        onApplyFilter(filters.startDate, filters.endDate);
    };

    return (
        <Dropdown closeOnSelect={false}>
            <DropdownTrigger>
                <Button radius='sm' variant='bordered' startContent={<FunnelIcon className='size-4' />}>
                    Saring
                </Button>
            </DropdownTrigger>
            <DropdownMenu aria-label="Filter Date">
                <DropdownItem isReadOnly>
                    <ControlledInput
                        name="startDate"
                        label="Tanggal Mulai"
                        type="date"
                        control={control}
                        isRequired
                        rules={{
                            required: "Tanggal Mulai harus diisi.",
                        }}
                    />
                </DropdownItem>
                <DropdownItem isReadOnly>
                    <ControlledInput
                        name="endDate"
                        label="Tanggal Selesai"
                        type="date"
                        control={control}
                        isRequired
                        rules={{
                            required: "Tanggal Selesai harus diisi.",
                        }}
                    />
                </DropdownItem>
                <DropdownItem isReadOnly>
                    <Button size='sm' color='primary' onClick={handleApply}>
                        Terapkan
                    </Button>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    )
}
